import React, { useState } from "react";
import {
  TableCell,
  TableRow,
  Collapse,
  Table,
  TableHead,
  TableBody,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { routes } from "@utils/constant";
import { utcToTimezone } from "@utils/commonFunctions";
import { Link } from "react-router-dom";

function Row(props) {
  const [open, setOpen] = useState(false);
  const { row, } = props;
  const handleAccordian = () => {
    setOpen(!open);
  };

  return (
    <>
      <TableRow onClick={handleAccordian} className="accordian-row">
        <TableCell className="check">
          <FormControlLabel
            className="custom-checkbox"
            control={
              <Checkbox
                icon={<img src={props.uncheckedIcon} alt="CheckBox" />}
                checkedIcon={
                  <img src={props.checkedIconOrange} alt="CheckBox" />
                }
                onChange={e => {
                  e.stopPropagation();
                  props.handleChange(row)
                }}
                onClick={e => e.stopPropagation()}
                checked={props.isItemSelected}
                name="check"
              />
            }
          />
        </TableCell>
        <TableCell className="jobId">
          <div className="prime-job">
            <ExpandMore className={open ? "consolidated-job-arrow active" : "consolidated-job-arrow not-active"} />
            <Link
              to={`#`}
              style={{ pointerEvents: "none" }}
            >
              {row.id ? `P-${row.id}` : "-"}
            </Link>
            <span className="badge">PRIME</span>
          </div>
        </TableCell>
        <TableCell>{row?.cities?.name || "-"}</TableCell>
        <TableCell className="customerName">
          {row.customers ? row.customers.name : "-"}
        </TableCell>
        <TableCell className="cto">
          {row.ctos ? row.ctos.name : "-"}
        </TableCell>
        <TableCell className="jobType">
          {row.jobTypes ? row.jobTypes.name : "-"}
        </TableCell>
        <TableCell className="cargoType">
          {row.cargoTypes ? row.cargoTypes.name : "-"}
        </TableCell>
        <TableCell
          className={`status ${props.dashboardRequestStatusColors(
            row.jobStatuses ? row.jobStatuses.name : "",
          )}`}
        >
          <span>
            {row.jobStatuses ? row.jobStatuses.name : "-"}
          </span>
        </TableCell>
        <TableCell className="date">
          {row.createdAt
            ? utcToTimezone(
              row.createdAt,
              row.cities?.timezone,
              "DD/MM/YYYY",
            )
            : "-"}
        </TableCell>
      </TableRow>
      <TableRow className="sub-row">
        <TableCell className="MuiTableSubRoW" colSpan={9}>
          <Collapse in={open} className="consolidated-job-collapse">
            <Table aria-label="simple table" className="consolidated-job">
              <TableHead>
                <TableRow>
                  <TableCell className="sub-job-id">
                    <div className="flex-box">
                      <span className="title-cell">Job ID</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-awb-number">
                    <div className="flex-box">
                      <span className="title-cell">AWB Number</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-weight">
                    <div className="flex-box">
                      <span className="title-cell">Weight</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-pieces">
                    <div className="flex-box">
                      <span className="title-cell">Pieces</span>
                    </div>
                  </TableCell>
                  <TableCell className="sub-ref-no">
                    <div className="flex-box">
                      <span className="title-cell">Ref No.</span>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {row?.primeConsolidatedJobs?.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className="sub-job-id">
                        <Link to={`${routes.jobDetail}/${item?.childJobId}`} target="_blank">
                          {item?.childJobId}
                        </Link>
                      </TableCell>
                      <TableCell className="sub-awb-number">{item?.childJob?.airWaybills[0]?.number}</TableCell>
                      <TableCell className="sub-weight">{item?.childJob?.airWaybills[0]?.weight}</TableCell>
                      <TableCell className="sub-pieces">{item?.childJob?.airWaybills[0]?.quantity}</TableCell>
                      <TableCell className="sub-ref-no">{item?.childJob?.referenceNo}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
